import { DestroyRef, Directive, inject, OnInit } from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroupDirective } from '@angular/forms';
import { skip, tap } from 'rxjs';

@Directive({ selector: '[appOnCountryChangesResetRegion]' })
export class OnCountryChangeResetRegionDirective implements OnInit {
  private readonly _fgDirective = inject(FormGroupDirective);
  private readonly _destroyRef = inject(DestroyRef);

  ngOnInit() {
    const form = this._fgDirective.form;

    if (!form) return;

    const countryControl = form.controls['country'];

    const regionControl = form.controls['region'];

    if (!countryControl || !regionControl) return;

    countryControl.valueChanges
      .pipe(
        skip(1),
        tap(() => {
          regionControl.setValue('');
        }),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe();
  }
}
